// The shell's line icons, from the approved prototype. Decorative: the control beside or around each
// one carries its name.
const PATHS = {
  today: <path d="M4 10l8-6 8 6v9a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z" />,
  chat: <path d="M4 5h16v11H9l-5 4z" />,
  floor: (
    <>
      <path d="M3 6h18M3 12h18M3 18h18" />
      <circle cx="8" cy="6" r="1.6" />
      <circle cx="15" cy="12" r="1.6" />
      <circle cx="11" cy="18" r="1.6" />
    </>
  ),
  documents: (
    <>
      <path d="M7 3h7l4 4v14H7z" />
      <path d="M10 12h6M10 16h6" />
    </>
  ),
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  search: (
    <>
      <circle cx="11" cy="11" r="6" />
      <path d="M20 20l-4.5-4.5" />
    </>
  ),
  bell: <path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6M10 19a2 2 0 0 0 4 0" />,
  chevron: <path d="M8 10l4 4 4-4" />,
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name }: { name: IconName }) {
  return (
    <svg
      className="icon"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {PATHS[name]}
    </svg>
  );
}
